import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Color, LegendPosition } from '@swimlane/ngx-charts';

interface Series {
  name: string;
  value: number;
}
interface Dataset {
  name: string;
  series?: Series[];
  value?: number;
}

@Component({
  selector: 'app-group-bar-chart',
  templateUrl: './group-bar-chart.component.html',
  styleUrl: './group-bar-chart.component.css',
  encapsulation: ViewEncapsulation.None
})
export class GroupBarChartComponent {

  @Input() chartId: string = '';
  @Input() datasets: Dataset[] = [];
  @Input() legendTitle: string = '';
  @Input() orientation: 'vertical' | 'horizontal' = 'vertical';
  @Input() variant: '2d' | 'single' = '2d';
  @Input() xAxisLabel: string = '';
  @Input() yAxisLabel: string = '';
  @Input() height: string = '';
  @Input() showLegend: boolean = true;
  @Input() scheme: string | Color = 'vivid';
  @Output() select = new EventEmitter<any>();

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  roundDomains: boolean = true;
  showDataLabel: boolean = true;
  animations: boolean = true;

  legendPosition = LegendPosition.Right;

  get showXAxisLabel(): boolean {
    return !!this.xAxisLabel;
  }
  get showYAxisLabel(): boolean {
    return !!this.yAxisLabel;
  }

  get colorScheme(): string | Color {
    return this.scheme;
  }

  constructor() {
    // Object.assign(this, { multi })
  }

  onSelect(data: any): void {
    this.select.emit(data);
  }
}
